import { Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'

export const QrBarcodeAnnotationInfo = () => {
  return (
    <PlatformAlert variant="info" showIcon={false} compact>
      <Stack>
        <Text fw={600} size="xs">
          <FormattedMessage id="annotation.qr_barcode.banner.title" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.qr_barcode.banner.description1" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.qr_barcode.banner.description2" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.qr_barcode.banner.tip.works" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.qr_barcode.banner.tip.notWorks" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.qr_barcode.banner.tip" />
        </Text>
      </Stack>
    </PlatformAlert>
  )
}
